export const LeaveTypeEnum = Object.freeze({
  Sick: 0,
  Casual: 1,
  Maternity: 2,
  Paternity: 3,
  Unpaid: 4,
});

export const LeaveTypeEnumLabel = Object.freeze({
  [LeaveTypeEnum.Sick]: "Sick Leave",
  [LeaveTypeEnum.Casual]: "Casual Leave",
  [LeaveTypeEnum.Maternity]: "Maternity Leave",
  [LeaveTypeEnum.Unpaid]: "Unpaid Leave",
});
